<template>
    <ThumbBase class="CourseThumb" :image="image" :title="title" :icon="icon" :ellipsis="false" @click="gotoCourse()">
        <div v-if="lifeskillId || tag" slot="tags" class="tags">
            <div v-if="tag" class="Tag">
                {{ tag }}
            </div>
            <LifeskillNumberTag v-if="lifeskillId" xclass="tag" :lifeskill-id="lifeskillId" />
        </div>
    </ThumbBase>
</template>

<translations>
  top: 'TOP'
  top_no: 'TOPP'
</translations>

<script>
import ThumbBase from './ThumbBase';
import LifeskillNumberTag from './LifeskillNumberTag';

export default {
    components: { ThumbBase, LifeskillNumberTag },
    props: {
        courseId: {
            type: String,
            required: true
        }
    },
    computed: {
        course() {
            return this.$store.state.moduleCourse.courses[this.courseId];
        },
        tag() {
            if (this.courseId === 'top-10') {
                return `${this.$t('top')} 10`;
            } else if (this.courseId === 'ls-40-no') {
                return `${this.$t('top')} 20`;
            } else if (this.courseId === 'history-course') {
                return `${this.$t('top')} 100`;
            } else {
                return '';
            }
        },
        lifeskillId() {
            return this.course.lifeskillNumber;
        },
        image() {
            return this.course.thumb;
        },
        title() {
            if (this.course.title) {
                return this.course.title;
            } else if (this.lifeskillId) {
                return this.$t(`dashboard.general.lifeskillLabelsSoftbreak.${this.lifeskillId}`);
            } else {
                return '';
            }
        },
        icon() {
            return '';
        }
    },
    methods: {
        gotoCourse() {
            if (this.lifeskillId) {
                this.$router.push({
                    name: 'DashboardLifeskillView',
                    params: {
                        lifeskillId: this.lifeskillId
                    }
                });
            } else {
                this.$router.push({
                    name: 'CourseHomeView',
                    params: {
                        courseId: this.courseId
                    }
                });
            }
        }
    }
};
</script>

<style lang="scss" scoped>
$transitionDuration: 0.3s;

.tags {
    display: flex;
    position: absolute;
    top: 1em;
    left: 1em;
}
.Tag {
    background-color: white;
    color: black;
    padding: 0.2em 0.4em;
    border-radius: 0.3em;
    font-size: 80%;

    margin-right: 0.5em;
}

.CourseThumb {
    width: (286em / 15);
    height: 13em;
}
</style>
